
import { Component, Vue } from "vue-property-decorator";
import appHeader from "./components/header.vue";
import appBanner from "./components/banner/index.vue";

@Component({
  components: {
    appHeader,
    appBanner,
  },
})
export default class Layout extends Vue {
  resourceCode = "102";
  /* get isCollapse() {
		  return this.$store.getters.isUnfold;
		} */
  get key() {
    return this.$route.path + Math.random();
  }
}
